<template>
  <div class="calculatorWrapper m-sm-auto">




    <h3>Se vad dina saker kostar när spotpriset är...</h3>
    <div class="my-4">
      <label>Välj elområde</label>
      <select class="form-select" aria-label="Välj elområde" @input="event => selectAreaSpot(event.target.value)">
        <option value="1">SE1</option>
        <option :selected="site == 'snara'" value="2">SE2</option>
        <option :selected="site == 'geab'" value="3">SE3</option>
        <option value="4">SE4</option>
      </select>
    </div>
    <div class="m-auto">
      <div ref="bubbleSpace" id="bubbleSpace" class="m-auto my-2 text-center" :style="{ 'width': 'calc(75% - 1rem)' }">
        <div class="bubble bg-dark  p-1 text-white" ref="bubble" style="width: 9rem"
          :style="{ 'margin-left': 'calc(' + sliderValue / 10 + '% - 4.5rem)' }">{{ sliderValue }} öre/kWh</div>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-lg bg-transparent flex-fill" @click="nudgeSlider('decrease')"> <i
            class="fa fa-angle-left fa-lg text-muted nudgeArrow" aria-hidden="true"></i></button>

        <input type="range" v-model="sliderValue" min="0" max="1000" class="w-75 form-range" id="slider" />
        <button class="btn btn-lg bg-transparent flex-fill" @click="nudgeSlider('increase')"><i
            class="fa fa-angle-right fa-lg text-muted text-right nudgeArrow" aria-hidden="true"></i></button>
      </div>
      <div class="d-flex w-75 m-auto">
        <small v-if="areaSpot > 250" @click="sliderValue = 0">0</small>
        <small @click="sliderValue = areaSpot"
          :style="{ 'marginLeft': 'calc(' + areaSpot / 10 + '% - 2.6rem)', 'width': '5rem', 'textAlign': 'center' }">just
          nu</small>
        <small v-if="areaSpot < 7250" @click="sliderValue = 1000" class="flex-fill text-end">1000
          öre/kWh</small>
      </div>


    </div>



    <table class="table table-sm my-5" style="font-size: 1rem;">
      <thead>
        <tr>
          <th class="ps-3 py-3 border-0" scope="col">Apparat</th>
          <th class="py-3 border-0" scope="col">Watt</th>
          <th class="py-3 border-0" scope="col">Tid</th>
          <th colspan="2" class="py-3 text-center border-0"> Kostnad</th>
          <th colspan="1" class="border-0"></th>

        </tr>
      </thead>


      <tbody class="border-0" v-if="ap.length == 0 || !ap">
        <tr>
          <td class="py3">Lägg till apparater från listan nedaför.</td>
        </tr>

      </tbody>
      <tbody v-else>
        <tr v-for="(item, i) in ap" :key="i">

          <td class="ps-sm-3 text-start ">
            <div type="button" @click="setupdateApItem(i)"
              class="bg-transparent text-start p-0 d-inline-block text-truncate" style="cursor: pointer;"
              data-bs-toggle="modal" data-bs-target="#updateApModal" v-html="item.name"></div>
          </td>
          <td class="">{{ item.watt }}</td>
          <td class="">{{ this.timeConvert(item.minutes) }}</td>
          <td ref="cost" class="cost text-end" @change="updateTotal"> {{ price(item.watt, item.minutes) }}</td>
          <td class="">kr</td>

          <td class="text-center p-0">
            <div @click="deleteApparatus(i, false)" class="btn bg-transparent text-muted"
              style="width: 36px; cursor: pointer;"><i class="far fa-trash fa-lg" aria-hidden="true"></i></div>
          </td>

        </tr>


      </tbody>

      <tr>
        <td colspan="3" class="border-top border-dark pt-3 ps-3">Summa:</td>
        <td colspan="1" class="border-top border-dark text-end pt-3 font-weight-bold">{{ total }}</td>
        <td colspan="4" class="border-top border-dark pt-3 font-weight-bold">kr</td>

      </tr>
    </table>
    <div class="accordion" id="apparatusAccordion">
      <div class="accordion-item">
        <h4 class="accordion-header bg-secondary" id="accordionHeading">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
            aria-expanded="true" aria-controls="collapseOne">

            Lägg till apparater
          </button>
        </h4>

        <div id="collapseOne" class="accordion-collapse collapse p-1" aria-labelledby="accordionHeading"
          data-parent="#apparatusAccordion">


          <form onsubmit="return false" class="mt-2">
            <div class="d-flex">
              <div class="form-group m-2 flex-fill">
                <label for="newApparatusName"><small>Apparat</small></label>
                <input class="form-control" v-model="newApparatusName" ref="newApparatusName" />

              </div>

              <div class="form-group m-2 flex-fill">
                <label for="newApparatusWatt"><small>Watt</small></label>
                <input id="newApparatusWatt" class="form-control" type="number" v-model="newApparatusWatt"
                  ref="newApparatusWatt" required />
              </div>

              <div class="form-group m-2 flex-fill">
                <label for="newApparatusMinutes"><small>Tid i minuter</small></label>
                <input class="form-control" v-model="newApparatusMinutes" id="newApparatusMinutes"
                  ref="newApparatusMinutes" type="number" required />

              </div>
            </div>
            <div class="row justify-content-md-end m-2">
              <button class="btn btn-primary col-md-3" @click="addNewApparatus">Lägg till</button>
            </div>

          </form>


          <table class="table table-sm my-5" style="font-size: 1rem;">

            <thead>
              <tr>
                <th class="ps-3" scope="col">Apparat</th>
                <th scope="col">Watt</th>
                <th scope="col">Tid</th>
                <th scope="col" class="text-end py-3 pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <template v-bind:key="i" v-for="(item, i) in extraAp">
                <tr class="">
                  <td class="ps-3 py-2" v-html="item.name"></td>
                  <td class="py-2">{{ item.watt }}</td>
                  <td class="py-2">{{ this.timeConvert(item.minutes) }}</td>

                  <td class="text-end">
                    <div @click="deleteApparatus(i, true)" class="text-muted" style="pointer: cursor;"><i
                        class="fa fa-plus fa-lg" aria-hidden="true"></i></div>
                  </td>

                </tr>
              </template>
            </tbody>

          </table>

        </div>
      </div>

    </div>
    <div id="addNew" />
    <!-- Modal -->

    <div class="modal fade" id="updateApModal" data-bs-backdrop="true" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="updateApModalLabel" aria-hidden="true" v-if="ap.length > 0">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="updateApModalLabel" v-html="ap[updateIndex].name"></h5>

            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <form onsubmit="return false">
              <div class="d-flex">
                <div class="m-2 flex-fill">


                  <label for="updateApparatusWatt">Watt</label>
                  <input id="updateApparatusWatt" ref="updateApparatusWatt" class="form-control" type="number"
                    :value="ap[updateIndex].watt" required />
                </div>

                <div class="m-2 flex-fill">

                  <label for="updateApparatusMinutes">Tid i minuter</label>
                  <input class="form-control" id="updateApparatusMinutes" ref="updateApparatusMinutes" type="number"
                    required :value="ap[updateIndex].minutes" />

                </div>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Avbryt</button>
            <button type="button" class="btn btn-success" data-bs-dismiss="modal" @click="updateAp()">Spara</button>
          </div>
        </div>
      </div>
    </div>

  </div>
  <ComponentStyles>

    .nudgeArrow {
    color: #020024
    }

    .calculatorWrapper table tbody tr td {
    vertical-align: middle !important;
    padding-vertical: 1rem;
    }



  </ComponentStyles>
</template>

<script>
import ComponentStyles from "../componentStyles.vue"
import apparater from "./apparater.json"

import { ref } from "vue";

export default {

  props: ['site'],

  data() {

    let ap = ref([]);
    const sliderValue = ref(0);
    const newApparatusName = ref();
    const newApparatusWatt = ref();
    const newApparatusMinutes = ref();
    const updateApparatusWatt = ref();
    const updateApparatusMinutes = ref();
    const bubbleSpace = ref();
    const updateIndex = 0;

    ap = apparater.slice(0, 8)
    let extraAp = apparater.slice(8)
    let areaSpot = null;



    return {
      areaSpot,
      ap,
      showAccordion: false,
      apListEmpty: false,
      extraAp,
      newApparatusName,
      newApparatusWatt,
      newApparatusMinutes,
      updateApparatusMinutes,
      updateApparatusWatt,
      updateIndex,
      sliderValue,
      bubbleSpace,
      total: 0,
      costs: [],
    }


  },
  components: { ComponentStyles },

  methods: {


    fetchPrice() {

      let url1 = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/geab-spotpriser/?elomrade=1&json";
      let url2 = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/geab-spotpriser/?elomrade=2&json";
      let url3 = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/geab-spotpriser/?elomrade=3&json";
      let url4 = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/geab-spotpriser/?elomrade=4&json";

      Promise.all([

        fetch(url1, { headers: { 'X-API-KEY': process.env.VITE_API_KEY }, }).then(res => res.json()),
        fetch(url2, { headers: { 'X-API-KEY': process.env.VITE_API_KEY }, }).then(res => res.json()),
        fetch(url3, { headers: { 'X-API-KEY': process.env.VITE_API_KEY }, }).then(res => res.json()),
        fetch(url4, { headers: { 'X-API-KEY': process.env.VITE_API_KEY }, }).then(res => res.json())

      ]).then(json => {
        this.se1 = json[0].content[0].prisetjustnu
        this.se2 = json[1].content[0].prisetjustnu
        this.se3 = json[2].content[0].prisetjustnu
        this.se4 = json[3].content[0].prisetjustnu



        if (this.site == "geab") {
          this.areaSpot = this.se3,
            this.sliderValue = this.areaSpot
        } else if (this.site == "snara") {
          this.areaSpot = this.se2,
            this.sliderValue = this.areaSpot
        }
      })
    },

    selectAreaSpot(area) {
      if (area == 1) { this.areaSpot = this.se1, this.sliderValue = this.se1 }
      if (area == 2) { this.areaSpot = this.se2, this.sliderValue = this.se2 }
      if (area == 3) { this.areaSpot = this.se3, this.sliderValue = this.se3 }
      if (area == 4) { this.areaSpot = this.se4, this.sliderValue = this.se4 }
    },


    addNewApparatus() {
      if (this.newApparatusName) {
        this.ap.push({
          name: this.newApparatusName,
          watt: this.newApparatusWatt,
          minutes: this.newApparatusMinutes
        });
        this.updateTotal()
      }

      (this.$refs["newApparatusName"]).focus();
    },

    deleteApparatus(index, extraAp) {

      if (extraAp) {
        let removed = this.extraAp.splice(index, 1)
        this.ap.push(removed[0])

      } else {
        let removed = this.ap.splice(index, 1)
        this.extraAp.push(removed[0])
      }



      this.updateTotal();

    },


    setupdateApItem(index) {
      this.updateIndex = index;
    },
    timeConvert(inMinutes) {
      var hours = (inMinutes / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return rhours > 0 && rminutes > 0 ? rhours + "tim. och " + rminutes + " min." : rhours > 0 ? rhours + " tim." : rminutes + " min."
    },

    price(watt, minutes) {

      let price = (this.sliderValue * (watt * 0.00001 * (minutes / 60))).toFixed(2)

      return price

    },

    updateTotal() {
      this.total = 0;

      if (this.ap.length) {
        this.ap.map(ap => {
          let price = (this.sliderValue * (ap.watt * 0.00001 * (ap.minutes / 60)))

          this.total += price * 1
        })

      }


      this.total = this.total.toFixed(2)
    },

    updateAp() {
      this.ap[this.updateIndex].watt = this.$refs.updateApparatusWatt.value;
      this.ap[this.updateIndex].minutes = this.$refs.updateApparatusMinutes.value;

    },

    nudgeSlider(nudge) {
      if (nudge == "increase") {
        this.sliderValue = this.sliderValue * 1 + 1
      }
      if (nudge == "decrease") {
        this.sliderValue -= 1
      }
    }


  },


  watch: {

    sliderValue:
    {

      handler: function () {
        this.updateTotal()
      }

    }
  },






  mounted() {

    this.fetchPrice()



  }



}
</script>
